function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M6.25601 0H14.744C18.1935 0 21 2.80643 21 6.25601V14.744C21 18.1936 18.1936 21 14.744 21H6.25601C2.80643 21 0 18.1936 0 14.744V6.25601C0 2.80643 2.80643 0 6.25601 0ZM14.7441 18.8874C17.0324 18.8874 18.8875 17.0323 18.8875 14.7439V6.25596C18.8875 3.9676 17.0324 2.11255 14.7441 2.11255H6.2561C3.96777 2.11255 2.11268 3.9676 2.11268 6.25596V14.7439C2.11268 17.0323 3.96777 18.8874 6.2561 18.8874H14.7441Z",
  fill: "#703965"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M5.06836 10.4997C5.06836 7.50486 7.50486 5.06836 10.4997 5.06836C13.4946 5.06836 15.9311 7.50482 15.9311 10.4997C15.9311 13.4945 13.4946 15.931 10.4997 15.931C7.50486 15.931 5.06836 13.4945 5.06836 10.4997ZM7.18109 10.4999C7.18109 12.3328 8.66692 13.8186 10.4998 13.8186C12.3327 13.8186 13.8186 12.3328 13.8186 10.4999C13.8186 8.66699 12.3327 7.18115 10.4998 7.18115C8.66696 7.18115 7.18109 8.66699 7.18109 10.4999Z",
  fill: "#703965"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M15.9421 6.41079C16.6609 6.41079 17.2435 5.8281 17.2435 5.10932C17.2435 4.39055 16.6609 3.80786 15.9421 3.80786C15.2233 3.80786 14.6406 4.39055 14.6406 5.10932C14.6406 5.8281 15.2233 6.41079 15.9421 6.41079Z",
  fill: "#703965"
});

var SvgInstagram = function SvgInstagram(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgInstagram, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/instagram.de4f6b30.svg";
export { ForwardRef as ReactComponent };